import { USERS, USER_STATUS } from '../../../constants';

const loadUsers = () => ({
  type: USERS.LOAD_REQUEST
});

const setUsers = users => ({
  type: USERS.LOAD_SUCCESS,
  users
});

const setUsersError = error => ({
  type: USERS.LOAD_FAIL,
  error
});

const loadUserStatus = (userId, pageNum = 0) => ({
  type: USER_STATUS.LOAD_REQUEST,
  userId,
  pageNum
});

const setUserStatus = ({ timestamp, activeTimestamps, userId }) => ({
  type: USER_STATUS.LOAD_SUCCESS,
  timestamp,
  activeTimestamps,
  userId
});

const setUserStatusError = error => ({
  type: USER_STATUS.LOAD_FAIL,
  error
});

export {
  loadUsers,
  setUsers,
  setUsersError,
  loadUserStatus,
  setUserStatus,
  setUserStatusError
};



// WEBPACK FOOTER //
// ./src/modules/Users/actions/index.js